import React, { useState } from 'react';
import './ToolPage.css';

const Base64Encoder = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState('encode');

  const encode = () => {
    try {
      const encoded = btoa(input);
      setOutput(encoded);
    } catch (e) {
      setOutput('Error: Input contains invalid characters for Base64 encoding');
    }
  };

  const decode = () => {
    try {
      const decoded = atob(input);
      setOutput(decoded);
    } catch (e) {
      setOutput('Error: Invalid Base64 string');
    }
  };

  const handleConvert = () => {
    if (mode === 'encode') {
      encode();
    } else {
      decode();
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
  };

  const clearAll = () => {
    setInput('');
    setOutput('');
  };

  const swapValues = () => {
    setInput(output);
    setOutput('');
  };

  return (
    <div className="tool-page">
      <div className="tool-header">
        <h1 className="tool-title">Base64 Encoder/Decoder</h1>
        <p className="tool-description">
          Encode and decode Base64 strings
        </p>
      </div>

      <div className="tool-content">
        <div className="mode-toggle">
          <button
            className={`mode-btn ${mode === 'encode' ? 'active' : ''}`}
            onClick={() => setMode('encode')}
          >
            Encode
          </button>
          <button
            className={`mode-btn ${mode === 'decode' ? 'active' : ''}`}
            onClick={() => setMode('decode')}
          >
            Decode
          </button>
        </div>

        <div className="textarea-row">
          <div className="textarea-group">
            <label className="input-label">
              {mode === 'encode' ? 'Text to Encode' : 'Base64 to Decode'}
            </label>
            <textarea
              className="textarea-field"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder={mode === 'encode' ? 'Enter text to encode' : 'Enter Base64 string to decode'}
              rows={8}
            />
          </div>

          <div className="textarea-group">
            <label className="input-label">Output</label>
            <textarea
              className="textarea-field"
              value={output}
              readOnly
              placeholder="Result will appear here"
              rows={8}
            />
          </div>
        </div>

        <div className="button-row">
          <button className="action-btn primary" onClick={handleConvert}>
            {mode === 'encode' ? 'Encode' : 'Decode'}
          </button>
          <button className="action-btn" onClick={swapValues} disabled={!output}>
            Swap ↔
          </button>
          <button className="action-btn" onClick={copyOutput} disabled={!output}>
            Copy Output
          </button>
          <button className="clear-btn" onClick={clearAll}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default Base64Encoder;
